export default __webpack_public_path__ + "static/media/anm-card.45d360b0.png";